import { ReactNode } from 'react';
import { Flex, FlexProps, useIsMobile } from '@blockanalitica/ui';
import { Link, Outlet } from 'react-router';
import styled from 'styled-components';
import Footer from './Footer';
import {
  default as SparkLogo
  // @ts-ignore
} from '@/assets/logos/spark_logo.svg?react';

const ContentContainer = styled(Flex)<FlexProps>`
  box-sizing: border-box;
  padding: ${(props) =>
    `${props.theme.space['s']} ${props.theme.space['s-m']} ${props.theme.space['s-m']}`};
`;

export default function BaseLayout({
  children
}: {
  children?: ReactNode | ReactNode[];
}) {
  const isMobile = useIsMobile();

  return (
    <ContentContainer
      flexGrow={1}
      flexShrink={1}
      flexBasis={['100%', 'auto']}
      margin="0 auto"
      width="100%"
      maxWidth={['100vw', '80rem']}
      flexDirection="column"
      justifyContent="space-between"
      gap="m">
      <Flex justifyContent="space-between" alignItems="center">
        <Link to="/">
          <SparkLogo height={isMobile ? 24 : 28} alt="SparkLend" />
        </Link>
      </Flex>

      <main>{children ? children : <Outlet />}</main>

      <Footer />
    </ContentContainer>
  );
}
